import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../features/auth/Login";
import { RoleBasedRoute } from "./RoleBasedRoute";
import { PublicRoute } from "./PublicRoute";

import PosPackages from "../features/packages/PosPackages";
import PosPackageDetail from "../features/packages/PosPackageDetail";
import PosSaleQrScreen from "../features/packages/PosSaleQrScreen";
import AssignSimPackages from "../features/packages/AssignSimPackages";
import TopupEsimOnly from "../features/packages/TopupEsimOnly";
import PublicHome from "../features/home/PublicHome";

import { ResellersList } from "../features/resellers/ResellerList";
import { PackagesList } from "../features/packages/PackageList";
import ResellerBalance from "../features/resellers/ResellerBalance";
import ResellerBusinessInfo from "../features/resellers/ResellerBusinessInfo";
import ResellerHomePage from "../features/resellers/ResellerHomePage";
import HelpSupportPage from "../features/resellers/HelpSupportPage";
import PricingPage from "../features/resellers/PricingPage";
import ContactSales from "../features/contact/ContactSales";
import ResellerLeadsPage from "../features/admin/ResellerLeadsPage";

// ✅ Admin Transactions page
import TransactionsPage from "../features/resellers/TransactionsPage";

// ✅ Reseller sidebar layout
import ResellerLayout from "../features/resellers/ResellerLayout";

// ✅ Reseller page
import MyClientsPage from "../features/resellers/MyClientsPage";
import AdminNotificationsPage from "../features/notifications/AdminNotificationsPage";
import ResellerNotificationsPage from "../features/notifications/ResellerNotificationsPage";

export function AppRoutes() {
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

  return (
    <Routes>
      {/* -------------------- LOGIN -------------------- */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route path="/contact-sales" element={<ContactSales />} />

      {!isAuthenticated && <Route path="/" element={<PublicHome />} />}

      {/* -------------------- RESELLER + COMMON (WITH SIDEBAR) -------------------- */}
      {isAuthenticated && (
        <Route
          element={
            <RoleBasedRoute>
              <ResellerLayout />
            </RoleBasedRoute>
          }
        >
          {/* ✅ IMPORTANT: use index route for "/" */}
          <Route index element={<ResellerHomePage />} />

          <Route path="plans" element={<PosPackages />} />
          <Route path="package/:id" element={<PosPackageDetail />} />
          <Route path="sale/qr" element={<PosSaleQrScreen />} />
          <Route path="topUpEsim" element={<TopupEsimOnly />} />
          <Route path="balance" element={<ResellerBalance />} />

          {/* ✅ NEW PAGE */}
          <Route path="clients" element={<MyClientsPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="help-support" element={<HelpSupportPage />} />
          <Route path="account/notifications" element={<ResellerNotificationsPage />} />
          <Route path="account/business-info" element={<ResellerBusinessInfo />} />

          {/* SIM reseller route */}
          <Route path="assign-sim-package" element={<AssignSimPackages />} />
        </Route>
      )}

      {/* -------------------- ADMIN (NO SIDEBAR) -------------------- */}
      <Route
        path="/resellers"
        element={
          <RoleBasedRoute>
            <ResellersList />
          </RoleBasedRoute>
        }
      />

      <Route
        path="/packages"
        element={
          <RoleBasedRoute>
            <PackagesList />
          </RoleBasedRoute>
        }
      />

      <Route
        path="/admin/transactions"
        element={
          <RoleBasedRoute>
            <TransactionsPage />
          </RoleBasedRoute>
        }
      />

      <Route
        path="/admin/notifications"
        element={
          <RoleBasedRoute>
            <AdminNotificationsPage />
          </RoleBasedRoute>
        }
      />

      <Route
        path="/admin/reseller-leads"
        element={
          <RoleBasedRoute>
            <ResellerLeadsPage />
          </RoleBasedRoute>
        }
      />

      {/* -------------------- FALLBACK -------------------- */}
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? "/" : "/login"} />}
      />
    </Routes>
  );
}
